import React, { Fragment } from "react";
import { Link, usePage } from "@inertiajs/inertia-react";
import { MenuAlt2Icon, BellIcon } from "@heroicons/react/outline";
import { Menu, Transition } from "@headlessui/react";
import cx from "classnames";
export default ({ setSidebarOpen }) => {
    const { auth } = usePage().props;

    const userNavigation = [
        {
            name: "Your Profile",
            route: null,
        },
        {
            name: "Change Password",
            route: route("settings.password"),
        },
        {
            name: "Sign out",
            route: route("logout"),
            method: "post",
        },
    ];

    return (
        <div className="sticky top-0 z-10 flex h-16 flex-shrink-0 bg-white shadow">
            <Link
                as={"button"}
                className={
                    "border-gray-200 px-4 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 md:hidden"
                }
                onClick={() => setSidebarOpen(true)}
            >
                <span className="sr-only">Open sidebar</span>
                <MenuAlt2Icon className="h-6 w-6" aria-hidden="true" />
            </Link>
            <div className="flex flex-1 justify-end px-4">
                <div className="ml-4 flex items-center md:ml-6">
                    <Link
                        as={"button"}
                        href={route("notifications")}
                        className="rounded-full bg-white p-1 text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    >
                        <span className="sr-only">View notifications</span>
                        <BellIcon className="h-6 w-6" aria-hidden="true" />
                    </Link>

                    {/* Profile dropdown */}
                    <Menu as="div" className="relative ml-3">
                        <div>
                            <Menu.Button className="flex max-w-xs items-center rounded-full bg-white text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                                <span className="sr-only">Open user menu</span>
                                <img
                                    src={auth.user.avatar}
                                    alt=""
                                    className="h-8 w-8 rounded-full"
                                />
                            </Menu.Button>
                        </div>
                        <Transition
                            as={Fragment}
                            enter={"transition ease-out duration-100"}
                            enterFrom={"transform opacity-0 scale-95"}
                            enterTo={"transform opacity-100 scale-100"}
                            leave={"transition ease-in duration-75"}
                            leaveFrom={"transition opacity-100 scale-100"}
                            leaveTo={"transition opacity-0 scale-95"}
                        >
                            <Menu.Items
                                className={
                                    "absolute right-0 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                                }
                            >
                                {userNavigation.map((item) => (
                                    <Menu.Item key={item.name}>
                                        {({ active }) => (
                                            <Link
                                                as={"button"}
                                                href={item.route}
                                                method={item.method || "get"}
                                                className={cx(
                                                    "block w-full px-4 py-2 text-left text-sm text-gray-700",
                                                    {
                                                        "bg-gray-100": active,
                                                    }
                                                )}
                                            >
                                                {item.name}
                                            </Link>
                                        )}
                                    </Menu.Item>
                                ))}
                            </Menu.Items>
                        </Transition>
                    </Menu>
                </div>
            </div>
        </div>
    );
};
